import React, { useState, useEffect,useRef } from 'react';
import clsx from 'clsx';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import useStyles from './index.style';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import ContentView from '@crema/core/ContentView';
import UserInfo from 'shared/components/UserInfo';
import Scrollbar from '@crema/core/Scrollbar';
import Navigation from '../../Navigation/VerticleNav/index';
import AppHeader from './AppHeader';
import { Box, useMediaQuery, Button } from '@material-ui/core';
import { toggleNavCollapsed, toggleDrawer } from 'redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ffAdminNavConfig } from 'navConfig/ffAdmin';
import { airlineAdminNavConfig } from 'navConfig/airlineAdmin';
import { airlineAgentNavConfig } from 'navConfig/airlineAgent';
import { dataEntryNavConfig } from 'navConfig/dataEntry';
import { ffAgentNavConfig } from 'navConfig/ffAgent';
import { shipperNavConfig } from 'navConfig/shipper';
import { ffClientNavConfig } from 'navConfig/ffClient';
import { superAdminNavConfig } from 'navConfig/superAdmin';
// import AppBreadcrumbs from 'shared/components/AppBreadcrumbs';
import Footer from 'shared/components/Footer';
import { styled, Theme, CSSObject } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import AnnouncementBanner from 'shared/components/AnnounceBanner/AnnouncementBanner';
import { dismissAnnouncement, setAnnouncementHeighttostore } from 'pages/mainPages/SuperAdmin/FreightForwarder/Admin/redux/actions';


const drawerWidth = 280;

const openedMixin = (theme,announcementHeight) => ({
  width: drawerWidth,
   marginTop: `${70 + announcementHeight}px`,
  [theme.breakpoints.down('480')]: {
      marginTop: `${56 + announcementHeight}px`,


  },

  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    // duration:theme.transitions.duration.enteringScreen
    duration: 700,

    // duration: 1000
  }),
  // overflowX: "hidden",
  // backgroundColor: "#32383e",

});



const closedMixin = (theme,announcementHeight) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    // duration: theme.transitions.duration.leavingScreen
    duration: 700,
  }),
  // overflowX: "hidden",
  // backgroundColor: "#32383e",
   marginTop: `${70 + announcementHeight}px`,
  [theme.breakpoints.down('480')]: {
   marginTop: `${56 + announcementHeight}px`,

  },

  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`
  }
});





// const Drawer = styled(MuiDrawer, {
//   shouldForwardProp: (prop)=>
//       prop !== "open" && prop !== "announcementHeight",

// })(({ theme, open,announcementHeight }) => ({
//   width: drawerWidth,
//   // flexShrink: 0,
//   // position:'absolute',

//   whiteSpace: "nowrap",
//   boxSizing: "border-box",
//   transition: theme.transitions.create("width", {
//     easing: theme.transitions.easing.sharp,
//   }
//   ),

//   ...(open && {
//     ...openedMixin(theme,announcementHeight),
//     "& .MuiDrawer-paper": openedMixin(theme,announcementHeight),
//     overflow: "hidden !important",
//   }),
//   ...(!open && {
//     ...closedMixin(theme,announcementHeight),
//     "& .MuiDrawer-paper": closedMixin(theme,announcementHeight),
//     overflow: "hidden !important",
//   })
// }));
const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop)=>
      prop !== "open" && prop !== "announcementHeight",

})(({ theme, open,announcementHeight }) => ({
  width: drawerWidth,
  whiteSpace: "nowrap",
  boxSizing: "border-box",

  "& .MuiDrawer-paper": {
    scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none", // IE/Edge
    "&::-webkit-scrollbar": {
      display: "none", // Chrome/Safari
    },
  },

  ...(open && {
    ...openedMixin(theme, announcementHeight),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme, announcementHeight),
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  }),
  ...(!open && {
    ...closedMixin(theme, announcementHeight),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme, announcementHeight),
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  }),
}));

export default function StandardLayout() {
  const [announcementHeight, setAnnouncementHeight] = useState(0);
const announcementRef = useRef(null);
    const {announcementData}=useSelector((state=>state.retrieveFreightForwarderAdminList));
    const [publishData,setPublishData]=useState([])
  const classes = useStyles();
  const theme = useTheme();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  useEffect(() => {
  const updateAnnouncementHeight = () => {
    if (announcementRef.current) {
      setAnnouncementHeight(announcementRef.current.offsetHeight);
      dispatch(setAnnouncementHeighttostore(announcementRef.current.offsetHeight))
    } else {
      setAnnouncementHeight(0);
            dispatch(setAnnouncementHeighttostore(0));

    }
  };

  updateAnnouncementHeight();

  window.addEventListener('resize', updateAnnouncementHeight);

  return () => {
    window.removeEventListener('resize', updateAnnouncementHeight);
        dispatch(setAnnouncementHeighttostore(0));

  };
}, [publishData]);



  const matchesLG = useMediaQuery(theme.breakpoints.up('lg'));

  // States
  const { user } = useSelector((state) => state.auth);
  const [currentNavConfig, setCurrentNavConfig] = useState([]);
  const navCollapsed = useSelector(({ settings }) => settings.navCollapsed);
  const openDrawer = useSelector(({ settings }) => settings.openDrawer);

  // const styling={
  //   change:{
  //     position:'absolute'
  //   },
  //   change1:{
  //     flexShrink:0
  //   }
  // }

  // Lifecycle Hook
  useEffect(() => {
    user?.role === 'ROLE_FFADMIN' && setCurrentNavConfig(ffAdminNavConfig);
    user?.role === 'ROLE_AIRLINE_ADMIN' && setCurrentNavConfig(airlineAdminNavConfig);
    user?.role === 'ROLE_AIRLINE_AGENT' && setCurrentNavConfig(airlineAgentNavConfig);
    user?.role === 'ROLE_DATAENTRY' && setCurrentNavConfig(dataEntryNavConfig);
    user?.role === 'ROLE_FFAGENT' && setCurrentNavConfig(ffAgentNavConfig);
    user?.role === 'ROLE_CONSIGNEE' && setCurrentNavConfig(shipperNavConfig);
    user?.role === 'ROLE_FFCLIENT' && setCurrentNavConfig(ffClientNavConfig);
    user?.role === 'ROLE_SUPERADMIN' && setCurrentNavConfig(superAdminNavConfig);
  }, [user]);

  // Functions
  const handleToggleDrawer = () => {
    dispatch(toggleNavCollapsed());
  };





  function drawerFuntion() {
    if (navCollapsed == false) {
      dispatch(toggleDrawer(true))
      setOpen(true)
    }
  }

  function closeDrawer() {
    if (navCollapsed == false)
      setOpen(false)
    dispatch(toggleDrawer(false))

  }


useEffect(() => {
  if (announcementData) {
    setPublishData(announcementData);
  }
}, [announcementData]);

  const handleCloseAnnouncement = (id) => {

  dispatch(
    dismissAnnouncement(
      id
    )
  );
};
  return (
    <div className={classes.root} >
      <CssBaseline />

      <AppHeader />
       {publishData?.length > 0 && (
  <Box
   ref={announcementRef}
    sx={{
      position: 'fixed',
      top: '70px',
      left: 0,
      width: '100%',
      zIndex: 1,
        display: 'flex',         
      flexDirection: 'column',  
      gap: '4px', 
      background:'#f4f7fe'

          }}
        >
          {publishData
            .filter((item) => item.isPublish === true)
            .map((item) => (
              <AnnouncementBanner
                key={item.id}
                announcement={item.message}
                onClose={() => handleCloseAnnouncement(item.id)}
                publishedDate={item?.createdTime}
                createdBy={item?.createdBy}
              />
            ))}
        </Box>
      )}
      <Drawer
        //   onMouseEnter={drawerFuntion}
        announcementHeight={announcementHeight}

        onMouseLeave={(navCollapsed == false && openDrawer == true) ? closeDrawer : ''}
        variant="permanent"
        open={(navCollapsed == false && openDrawer == true) || (navCollapsed == true && openDrawer == false)}
        classes={{
          paper: classes.drawerPaper,
        }}
        // style={navCollapsed?styling.change1:styling.change}
        onClose={() => handleToggleDrawer()}
      >
        {/* <UserInfo handleToggleDrawer={handleToggleDrawer} /> */}
        {/* <Divider /> */}
        <Scrollbar scrollToTop={false}
          className={classes.drawerScrollAppSidebar}
        >
          <Navigation />
        </Scrollbar>
      </Drawer>

      <main
        className={clsx(navCollapsed ? classes.content1 : classes.content, {
          [classes.contentShift]: navCollapsed
        })}
      >
        {/* <div className={classes.drawerHeader} /> */}

        <>
          <Box className={classes.mainContent}>
            <Box className={classes.mainContainer}   style={{
    marginTop: `${announcementHeight}px`,
  }}>
              {/* <div
                style={{
                  marginLeft: '18px',
                  marginRight: '35px',
                  display: 'inline-block',
                }}
              >
                <AppBreadcrumbs currentNavConfig={currentNavConfig} pathname={pathname} />
              </div> */}

              <ContentView />
            </Box>
          </Box>
          <Footer />
        </>
      </main>
    </div>
  );
}
